import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-red-900/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_eef57605-b57f-42da-9484-428b5038f0b4/artifacts/n8pfvrwl_640882159_1565121207907925_6876786731636828058_n.jpg" 
              alt="Swift HandyMen" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Professional handyman services for Tampa Bay and surrounding areas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4" style={{ color: '#FFD700' }}>
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-400 hover:text-red-500 transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-400 hover:text-red-500 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-400 hover:text-red-500 transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-red-500 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4" style={{ color: '#FFD700' }}>
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400">
                <Phone className="w-5 h-5 mr-3 text-red-500" />
                <a href="tel:8134491138" className="hover:text-red-500 transition-colors">
                  (813) 449-1138
                </a>
              </li>
              <li className="flex items-center text-gray-400">
                <Mail className="w-5 h-5 mr-3 text-red-500" />
                <a href="mailto:info@swifthandymen.com" className="hover:text-red-500 transition-colors">
                  info@swifthandymen.com
                </a>
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin className="w-5 h-5 mr-3 text-red-500 mt-1" />
                <span>Serving Tampa Bay & Surrounding Areas</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-red-900/20 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Swift HandyMen. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            *For services requiring permits or licensed trade work, we coordinate with trusted licensed professionals when needed.
          </p>
          <p className="text-gray-500 text-xs mt-3">
            Website Created by <a href="https://www.GregMiceli.com" target="_blank" rel="noopener noreferrer" className="hover:text-red-500 transition-colors underline">www.GregMiceli.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
